<template>
    <div>
        <div class="device-manage">
        <div class="display-flex justify-between flex-wrap mb-40">
            <div class="display-flex col-12 col-lg-3">
            <div
                v-for="(item, index) in DeviceSumary"
                :key="index"
                class="display-flex col-6 device-unlocked align-center"
            >
                <img :src="item.icon" class="icon-status display-flex align-center" />
                <div>
                <div class="status-device">
                    <div class="item-count">
                    {{ item.number }}
                    </div>
                    <div class="item-status">
                    {{ item.status }}
                    </div>
                </div>
                <div class="item-unit">
                    {{ item.unit }}
                </div>
                </div>
            </div>
            </div>
            <div class="display-flex col-12 col-lg-6 filter-container">
            <ButtonComponent
                label="Add New Device"
                :width="181"
                :height="isSmallScreen ? 40 : 56"
                :onClick="handleAddEdit"
                :outlined="false"
                :disabled="!getterAccessibleMenus?.asset.action"
            />
            <InputComponent
                class="input-search"
                :showLabel="false"
                v-model="search"
                :height="56"
                @enter="handleSearch"
                placeholder="Search..."
                iconInput="mdi mdi-magnify"
            />
            </div>
        </div>
        <TableComponent
            :items="formattedDevices"
            :headers="headers"
            :page="page"
            :total="total"
            :disabled="!getterAccessibleMenus?.asset.action"
            @view="handleView"
            @edit="handleAddEdit"
            @delete="handleDelete"
            @on-change-page="onChangePage"
            @on-sort="handleSort"
        />
        </div>
        <!-- Device Information -->
        <ModalComponent
        v-if="showModalDetail.isShow"
        :width="477"
        titleHeader="Device Information"
        :widthButtonFooter="397"
        aciontCenter
        :onModalCancelEvent="handleTurnOffModalDetail"
        :isShowBtnSave="false"
        >
        <template v-slot:action>
            <div class="icon-action-title">
            <img :class="{ 'disabled-icon': !getterAccessibleMenus?.asset.action }" :src="ICON_EDIT"  @click="!getterAccessibleMenus?.asset.action ? null : handleAddEdit(showModalDetail.data)"/>
            <img :class="{ 'disabled-icon': !getterAccessibleMenus?.asset.action }" :src="ICON_DELETE" @click="!getterAccessibleMenus?.asset.action ? null : handleDelete(showModalDetail.data)" />
            </div>
        </template>
        <div class="device-infomation-detail">
            <div class="infomation-detail">
            <div class="title-detail">Site Name</div>
            <div class="value-detail">{{ listSites.find(t => t.id === showModalDetail.data.site_id)?.name || showModalDetail.data.site_name }}</div>
            </div>
            <div class="infomation-detail">
            <div class="title-detail">Device Name</div>
            <div class="value-detail">{{ showModalDetail.data.name }}</div>
            </div>
            <div class="infomation-detail">
            <div class="title-detail">Serial Number</div>
            <div class="value-detail">{{ showModalDetail.data.sn }}</div>
            </div>
            <div class="infomation-detail">
            <div class="title-detail">Original Serial Number</div>
            <div class="value-detail">{{ showModalDetail.data.original_sn ?? 'N/A'}}</div>
            </div>
            <div class="infomation-detail">
            <div class="title-detail">Model</div>
            <div class="value-detail">{{ showModalDetail.data.model ?? 'N/A'}}</div>
            </div>
            <div class="infomation-detail">
            <div class="title-detail">Brand</div>
            <div class="value-detail">{{ showModalDetail.data.brand ?? 'N/A'}}</div>
            </div>
            <div class="infomation-detail">
            <div class="title-detail">Status</div>
            <div class="value-detail">{{ showModalDetail.data.status }}</div>
            </div>
            <div class="infomation-detail">
            <div class="title-detail">Type</div>
            <div class="value-detail">{{ types.find(t => t.code === showModalDetail.data.type)?.name || showModalDetail.data.type }}</div>
            </div>
            <div class="infomation-detail">
            <div class="title-detail">Offline Reason</div>
            <div class="value-detail">{{ showModalDetail.data.offline_reason ?? 'N/A'}}</div>
            </div>
            <div class="infomation-detail">
            <div class="title-detail">Inventory Status</div>
            <div class="value-detail">{{ showModalDetail.data.inventory_status ?? 'N/A'}}</div>
            </div>
            <!-- <div class="infomation-detail">
            <div class="title-detail">Install Status</div>
            <div class="value-detail">{{ list_status.find(t => t.code === showModalDetail.data.install_status)?.name || showModalDetail.data.install_status }}</div>
            </div> -->
            <div class="infomation-detail">
            <div class="title-detail">Commission Date</div>
            <div class="value-detail">{{ showModalDetail.data.date_of_commission ?? '-'}}</div>
            </div>
            <div class="infomation-detail">
            <div class="title-detail">Nexus Device ID</div>
            <div class="value-detail">{{ showModalDetail.data.nexus_asset_id ?? 'N/A'}}</div>
            </div>
            <div class="infomation-detail">
            <div class="title-detail">Next Maintenance</div>
            <div class="value-detail">{{ showModalDetail.data.next_maintenance ?? '-'}}</div>
            </div>
            <div class="infomation-detail">
            <div class="title-detail">Rated Capacity</div>
            <div class="value-detail">{{ showModalDetail.data.rated_capacity ?? 'N/A'}}</div>
            </div>
            <div class="infomation-detail">
            <div class="title-detail">PV Lower Limit</div>
            <div class="value-detail">{{ showModalDetail.data.pv_lower_limit ?? 'N/A' }}</div>
            </div>
            <div class="infomation-detail">
            <div class="title-detail">Software Version</div>
            <div class="value-detail">{{ showModalDetail.data.software_version ?? 'N/A'}}</div>
            </div>
            <div class="infomation-detail">
            <div class="title-detail">Device Key</div>
            <div class="value-detail">{{ showModalDetail.data.device_key ?? 'N/A'}}</div>
            </div>
            <!-- <div class="infomation-detail">
            <div class="title-detail">Update At</div>
            <div class="value-detail">{{ showModalDetail.data.updated_at }}</div>
            </div> -->
            <!-- <div class="infomation-detail">
            <div class="title-detail">Created At</div>
            <div class="value-detail">{{ showModalDetail.data.created_at }}</div>
            </div> -->
        </div>
        </ModalComponent>
        <!-- New device added successfully -->
        <ModalComponent
        v-if="showModalAddSuccess"
        :width="672"
        titleHeader="New device added successfully"
        btnCancel="MANAGE DEVICES"
        btnSave="ADD NEW DEVICE"
        :widthButtonFooter="288"
        :onModalCancelEvent="handleTurnOffModalAddSuccess"
        :onModalSaveEvent="handleBtnAddModalAddSuccess"
        >
        <div class="device-infomation-add-success">
            <div class="notify-success">
            <div class="notify">
                Congratulations! The new device has been successfully added to the
                system.
            </div>
            <div class="notify">New device information:</div>
            </div>
            <div class="infomation-success">
            <div class="title-info">Site:</div>
            <div class="value-info">{{ listSites?.find(t => t.id === newDeviceInfomation.site_id)?.name || newDeviceInfomation.site_name }}</div>
            </div>
            <div class="infomation-success">
            <div class="title-info">Device Name:</div>
            <div class="value-info">{{ newDeviceInfomation?.name }}</div>
            </div>
            <div class="infomation-success">
            <div class="title-info">Serial Number:</div>
            <div class="value-info">{{ newDeviceInfomation?.sn }}</div>
            </div>
            <div class="infomation-success">
            <div class="title-info">Type:</div>
            <div class="value-info">{{ types?.find(it => it.code === newDeviceInfomation?.type)?.name || newDeviceInfomation?.type  }}</div>
            </div>
            <div class="infomation-success">
            <div class="title-info">Model:</div>
            <div class="value-info">{{ newDeviceInfomation?.model }}</div>
            </div>
            <div class="infomation-success">
            <div class="title-info">Brand:</div>
            <div class="value-info">{{ newDeviceInfomation?.brand }}</div>
            </div>
            <div class="infomation-success">
            <div class="title-info">Original Serial Number:</div>
            <div class="value-info">{{ newDeviceInfomation?.original_sn }}</div>
            </div>
            <div class="infomation-success">
            <div class="title-info">Rated Capacity:</div>
            <div class="value-info">{{ newDeviceInfomation?.rated_capacity }}</div>
            </div>
            <div class="infomation-success">
            <div class="title-info">PV Lower Limit:</div>
            <div class="value-info">{{ newDeviceInfomation?.pv_lower_limit }}</div>
            </div>
            <div class="notify">
            You can go back to the "Manage Devices" page to view the list of devices
            or continue adding new devices.
            </div>
        </div>
        </ModalComponent>
        <!-- Delete Device -->
        <ModalComponent
        v-if="showDeleteConfirm.isShow"
        titleHeader="Delete Device"
        :widthButtonFooter="288"
        :onModalCancelEvent="handleOffConfirmDelete"
        :onModalSaveEvent="handleDeleteSuccess"
        btnSave="CONFIRM"
        >
        <div class="delete-device-confirm">
            <div class="notify">Are you sure you want to delete this device?</div>
            <div class="infomation-confirm">
            <div class="title-info">Site Name:</div>
            <div class="value-info">{{ listSites?.find(t => t.id === showDeleteConfirm.data.site_id)?.name || showDeleteConfirm.data.site_name }}</div>
            </div>
            <div class="infomation-confirm">
            <div class="title-info">Device Name:</div>
            <div class="value-info">{{ showDeleteConfirm.data.name }}</div>
            </div>
            <div class="infomation-confirm">
            <div class="title-info">Serial Number:</div>
            <div class="value-info">{{ showDeleteConfirm.data.sn }}</div>
            </div>
            <div class="infomation-confirm">
            <div class="title-info">Type:</div>
            <div class="value-info">{{ types?.find(t => t.code === showDeleteConfirm.data.type)?.name || showDeleteConfirm.data.type }}</div>
            </div>
        </div>
        </ModalComponent>
        <!-- Device Deleted Successfully -->
        <ModalComponent
        v-if="showDeleteSuccess"
        titleHeader="Device Deleted Successfully"
        :widthButtonFooter="257"
        :onModalCancelEvent="handleTurnOffDeleteSuccess"
        :isShowBtnSave="false"
        btnCancel="CLOSE"
        actionRight
        >
        <div class="notify">
            The device has been successfully deleted from the system.
        </div>
        </ModalComponent>

        <!-- Edit Success / Add New Device-->
        <ModalComponent
        v-if="showModal.isShow"
        :width="780"
        :titleHeader="showModal.id ? 'Edit Device' : 'Add New Device'"
        :onModalSaveEvent="onSubmit"
        :onModalCancelEvent="showModal.id ? handleTurnOffModalEdit: handleTurnOffModalAdd"
        :widthButtonFooter="327"
        >
        <form class="form-edit-add-device" @submit.prevent="onSubmit" v-validate>
            <div class="form-device">
            <SelectComponent
                :items="listSites"
                fieldLabel="Site"
                name="Site"
                v-bind="$attrs"
                :outlined="false"
                placeholder="Select Site"
                v-model="site"
                display="name"
                v-validate="'required'"
                :disabled="!!showModal.id"
                :errorMessage="errors.first('Site')" 
            />
            </div>
            <div class="form-device">
            <InputComponent
                type="text"
                name="name"
                v-model="name"
                v-validate="{
                required: true,
                number_of_characters: { fieldType: 'Name' },
                }"
                fieldLabel="Device Name"
                @blur="$validator.validate('Device Name')"
                :outlined="false"
                placeholder="Enter Device Name"
                :errorMessage="errors.first('Name')"
            />
            </div>
            <div class="form-device">
            <InputComponent
                type="text"
                name="sn"
                v-model="sn"
                v-validate="{
                required: true,
                validSerialNumber
                }"
                fieldLabel="Serial Number"
                :outlined="false"
                :disabled="!!showModal.id"
                @blur="$validator.validate('Serial Number')"
                placeholder="Enter Serial Number"
                :errorMessage="errors.first('Serial Number')"
            />
            </div>
            <div class="form-device">
            <SelectComponent
                :items="types"
                fieldLabel="Type"
                name="type"
                v-bind="$attrs"
                :outlined="false"
                :disabled="true"
                placeholder="Auto-detected"
                v-model="type"
                display="name"
                v-validate="'required'"
                :errorMessage="errors.first('Type')"
            />
            </div>
            <div v-if="selectedSiteHasNexusId" class="form-device">
            <InputComponent
                type="text"
                name="Nexus Device ID"
                v-model="nexus_asset_id"
                v-validate="!showModal.id ? 'required' : ''"
                fieldLabel="Nexus Device ID"
                :outlined="false"
                :disabled="!!showModal.id"
                @blur="$validator.validate('Nexus Device ID')"
                placeholder="Enter Nexus Device ID"
                :errorMessage="errors.first('Nexus Device ID')"
            />
            </div>
            <div class="form-device">
            <InputComponent
                type="text"
                name="Model"
                v-model="model"
                v-validate="{
                required: true,
                number_of_characters: { fieldType: 'Model' }
                }"
                fieldLabel="Model"
                :outlined="false"
                placeholder="Enter Model"
                :errorMessage="errors.first('Model')"
            />
            </div>
            <div class="form-device">
            <InputComponent
                type="text"
                name="Brand"
                v-model="brand"
                v-validate="{
                required: true,
                number_of_characters: { fieldType: 'Brand' }
                }"
                fieldLabel="Brand"
                :outlined="false"
                placeholder="Enter Brand"
                :errorMessage="errors.first('Brand')"
            />
            </div>
            <div class="form-device">
            <InputComponent
                type="text"
                name="Original Serial Number"
                v-validate="{
                required: false,
                number_of_characters: { fieldType: 'Original Serial Number' }
                }"
                v-model="original_sn"
                fieldLabel="Original Serial Number"
                :fieldRequired="false"
                :outlined="false"
                placeholder="Enter Original Serial Number"
                :errorMessage="errors.first('Original Serial Number')"
            />
            </div>
            <div class="form-device">
            <InputComponent
                type="text"
                name="Rated Capacity"
                v-validate="{
                required: false,
                number_of_characters: { fieldType: 'Rated Capacity' }
                }"
                v-model="rated_capacity"
                fieldLabel="Rated Capacity"
                :outlined="false"
                :fieldRequired="false"
                placeholder="Enter Rated Capacity"
                :errorMessage="errors.first('Rated Capacity')"
            />
            </div>
            <div class="form-device">
            <InputComponent
                type="text"
                name="PV Lower Limit"
                v-model="pv_lower_limit"
                v-validate="{
                required: false,
                number_of_characters: { fieldType: 'PV Lower Limit' }
                }"
                fieldLabel="PV Lower Limit"
                :outlined="false"
                :fieldRequired="false"
                placeholder="Enter PV Lower Limit"
                :errorMessage="errors.first('PV Lower Limit')"
            />
            </div>
        </form>
        </ModalComponent>
        <!-- Edit device successfully -->
        <ModalComponent
        v-if="showModalEditSuccess"
        :width="672"
        titleHeader="Edit device successfully"
        :widthButtonFooter="288"
        :isShowBtnSave="false"
        actionRight
        btnCancel="CLOSE"
        :onModalCancelEvent="handleTurnOffModalEditSuccess">
        <div class="device-infomation-edit-success">
            <div class="notify-success">
            <div class="notify">
                The device has been successfully edited from the system.
            </div>
            <div class="notify">Device information:</div>
            </div>
            <div class="infomation-success">
            <div class="title-info">Site:</div>
            <div class="value-info">{{ listSites?.find(t => t.id === newDeviceInfomation?.site_id)?.name || "" }}</div>
            </div>
            <div class="infomation-success">
            <div class="title-info">Device Name:</div>
            <div class="value-info">{{ newDeviceInfomation?.name }}</div>
            </div>
            <div class="infomation-success">
            <div class="title-info">Serial Number:</div>
            <div class="value-info">{{ newDeviceInfomation?.sn }}</div>
            </div>
            <div class="infomation-success">
            <div class="title-info">Type:</div>
            <div class="value-info">{{ types?.find(it => it.code === newDeviceInfomation?.type)?.name || newDeviceInfomation?.type }}</div>
            </div>
            <div class="infomation-success">
            <div class="title-info">Model:</div>
            <div class="value-info">{{ newDeviceInfomation?.model }}</div>
            </div>
            <div class="infomation-success">
            <div class="title-info">Brand:</div>
            <div class="value-info">{{ newDeviceInfomation?.brand }}</div>
            </div>
            <div class="infomation-success">
            <div class="title-info">Original Serial Number:</div>
            <div class="value-info">{{ newDeviceInfomation?.original_sn ?? 'N/A' }}</div>
            </div>
            <div class="infomation-success">
            <div class="title-info">Rated Capacity:</div>
            <div class="value-info">{{ newDeviceInfomation?.rated_capacity ?? 'N/A' }}</div>
            </div>
            <div class="infomation-success">
            <div class="title-info">PV Lower Limit:</div>
            <div class="value-info">{{ newDeviceInfomation?.pv_lower_limit ?? 'N/A' }}</div>
            </div>
        </div>
        </ModalComponent>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";

import {
  ICON_ASSET_COUNT,
  ICON_COMMISSION_PROCESS,
  ICON_COMMISSION_FAILURE,
  ICON_COMMISSION_SUCCESS,
  ICON_EDIT,
  ICON_DELETE,
} from "@/theme/image";

import TableComponent from "@/components/TableComponent.vue";
import ButtonComponent from "@/components/ButtonComponent.vue";
import InputComponent from "@/components/InputComponent.vue";
import ModalComponent from "@/components/ModalComponent.vue";
import SelectComponent from "@/components/SelectComponent.vue";
// import AutocompleteComponent from "@/components/AutocompleteComponent.vue";
import { Validator } from 'vee-validate';

Validator.extend('number_of_characters', {
  getMessage: field => {
    if (['Name', 'Model', 'Brand'].includes(field)) {
      return 'The ' + field + ' field must be 1 to 255 characters.'
    }
    if (['Rated Capacity', 'Original Serial Number', 'PV Lower Limit'].includes(field)) {
      return 'The ' + field + ' field must be less than 255 characters.'
    }
    // Thông báo mặc định
    return 'The ' + field + ' does not meet the character requirements.';
  },
  validate: (value, args) => {
    const fieldType = args.fieldType || 'default';
    if (['Name', 'Model', 'Brand'].includes(fieldType) && (value.length < 1 || value.length > 255)) {
      return {
        valid: false
      };
    }
    if (['Rated Capacity', 'Original Serial Number', 'PV Lower Limit'].includes(fieldType) && (value.length < 0 || value.length > 255)) {
      return {
        valid: false
      };
    }
    return {
      valid: true
    };
  }
});
Validator.extend('validSerialNumber', {
  getMessage: 'The Serial Number field must be xxxx-xxxx-xxxx',
  validate: value => {
    if (!/^\d{4}-\d{4}-[a-zA-Z0-9]{4}$/.test(value)) {
      return {
        valid: false
      };
    }
    return {
      valid: true
    };
  }
});
Validator.extend('validPassword', {
  getMessage: field => field + ' must contain at least one lowercase letter, one uppercase letter, one number and one special character.',
  validate: value => {
    const hasletter = /[a-z]/.test(value); 
    const hasUppercase = /[A-Z]/.test(value); 
    const hasNumber = /[0-9]/.test(value); 
    const hasSpecialCharacter = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>?]/.test(value);

    if (!hasUppercase || !hasNumber || !hasSpecialCharacter || !hasletter) {
      return {
          valid: false
      };
    }
    return {
      valid: true
    };
  }
});

Validator.extend('maxValidEmail', {
  getMessage: field => 'The '+field.toLowerCase() + ' must not exceed 255 character',
  validate: value => {
    if (value.length > 255) {
      return {
        valid: false
      };
    }
    return {
      valid: true
    };
  }
});
Validator.extend('validEmail', {
  getMessage: field => 'The '+field.toLowerCase() + ' is invalid.',
  validate: value => {
    const validEmail = /^[a-z0-9]+([/.\-_]?[a-z0-9]+)*([+][a-z0-9]+)?@[a-z0-9]+([/.\-_]?[a-z0-9]+)*(\.[a-z0-9]{2,})+$/i.test(value); 
    if (!validEmail) {
      return {
          valid: false
      };
    }
    return {
      valid: true
    };
  }
});
export default {
  name: "AssetManagement",
  components: {
    TableComponent,
    ButtonComponent,
    InputComponent,
    ModalComponent,
    SelectComponent,
  },
  data() {
    return {
      isNexus: false,
      nexus_asset_id: null,
      name: "",
      site_name: "",
      sn: "",
      type: [],
      model: "",
      brand: "",
      original_sn: "",
      rated_capacity: "",
      pv_lower_limit: "",
      site: [],
      status: "",
      idEdit: "",
      data_sort: "",
      data_sort_filter:"",
      newDeviceInfomation: {},
      showModal:{
        isShow: false,
        data: null,
        id: null,
      },
      showModalDetail: {
        isShow: false,
        data: null,
      },
      showModalAddSuccess: false,
      showDeleteConfirm: {
        isShow: false,
        data: null,
      },
      showDeleteSuccess: false,
      showModalEditSuccess: false,
      key: "",
      modalVisible: false,
      DeviceSumary: [],
      items: [],
      headers: [
        { text: "ID", value: "id", width: 5, divider: true, sortable: false },
        { text: "Site Name", value: "site_name", width: 250, divider: true },
        { text: "Device Name", value: "name", width: 250, divider: true },
        { text: "Device Type", value: "type_name", sortable: false, width: 20, divider: true },
        { text: "Status", value: "status", sortable: false, width: 20, divider: true },
        { text: "Offline Reason", value: "offline_reason", width: 200, sortable: false, divider: true },
        // { text: "Installation", value: "install_status_name", sortable: false, width: 50, divider: true },
        { text: "Commission Date", value: "date_of_commission", width: 60, sortable: false, divider: true },
        // { text: "Configuration", value: "config", width: 390, sortable: false, divider: true },
        { text: "Next Maintenance", value: "next_maintenance", sortable: false, width: 60, divider: true },
        { text: "Rated Capacity", value: "rated_capacity", sortable: false, width: 60, divider: true },
        // { text: "Software Version", value: "software_version", width: 60, divider: true },
        { text: "Actions", value: "actions", width: 120, sortable: false },
      ],
      search: "",
      page: 1,
      total: null,
      isSmallScreen: window.innerWidth < 1440,
      ICON_EDIT,
      ICON_DELETE,
      validSerialNumber: null,
      validPassword: null,
      validEmail: null,
      maxValidEmail: null,
      types: [{ id: '01', code: 'sc', name: 'Site Controller'}, { id: '02', code: 'pv', name: 'Photovoltaic'}, { id: '04', code: 'pm', name: 'Power Meter'}, { id: '05', code: 'bess', name: 'BESS'}, { id: '03', code: 'evse', name: 'EV Charger'},],
      
      list_status: [{id: 1, code: 'uncommissioned', name: 'Pending'}, {id: 2, code: 'commissioning', name: 'Commissioning'}, {id: 3, code: 'waiting_result', name: 'Responding'}, {id: 4, code: 'success', name: 'Success'}, {id: 5, code: 'failed', name: 'Failed'}]
    };
  },
  created() {
    window.addEventListener("resizeButton", this.handleResize);
    this.handleResize();
  },
  mounted() {
    this.fetchData();
    this.fetchDataSites();
  },
  computed: {
    ...mapState('deviceManager',['deviceManager']),
    ...mapGetters("deviceManager", {
      deviceManager: "getterDeviceManager",
      listSites: "getterSites",
    }),
    ...mapGetters("common", {
      getterAccessibleMenus: "getterAccessibleMenus",
    }),

    formattedDevices() {
      return this.deviceManager.map(device => {
        const status = this.list_status?.find(s => s.code === device.install_status)?.name;
        const type = this.types?.find(t => t.code === device.type)?.name
        return {
          ...device,
          type_name: type || device.type,
          install_status_name: status || device.install_status,
        };
      });
    },

    displayNames: function () {
      return function (data) {
        return data.map(item => item.name).join(', ');
      }
    },

    selectedSiteHasNexusId() {
      if (!this.site) return false;
      const found = this.listSites.find(s => s.id === this.site.id);
      return found && found.nexus_id != null && found.nexus_id !== "";
    }
  },
  methods: {
    ...mapActions("deviceManager", {
      getListDevice: "getListDevice",
      getDeviceInfo: "getDeviceInfo",
      getListSites: 'getListSites',
      deleteDevice: 'deleteDevice',
      addDevice: 'addDevice',
      editDevice: 'editDevice',
      
    }),
    ...mapActions("common", ["getProfileUser"]),
    async fetchData(param) {
      const res = await this.getListDevice({
        page: this.page,
        per_page: 10,
        sort: this.data_sort,
        sort_filter: this.data_sort_filter,
        txt_search: this.search,
        ...param,
      });

      this.total = res?.data.total_count;

      this.DeviceSumary = [
        {
          icon: ICON_ASSET_COUNT,
          number: res?.data.total_count,
          unit: "Total",
        },
        {
          icon: ICON_COMMISSION_PROCESS,
          number: res?.data.register_count,
          unit: "Total Register",
        },
        {
          icon: ICON_COMMISSION_SUCCESS,
          number: res?.data.online_count,
          unit: "Total Online",
        },
        {
          icon: ICON_COMMISSION_FAILURE,
          number: res?.data.alarm_count,
          unit: "Total Alarm",
        },
      ];      
      return res;
    },

    async fetchDataSites(param) {
      await this.getListSites(param);
    },

    async onSubmit() {
      if (this.showModal.id) {
        const result = await this.$validator.validateAll();
        if (result) {
          const res = await this.editDevice({
            name: this.name?.trim(),
            id: this.idEdit,
            type: this.type.code,
            model: this.model,
            brand: this.brand,
            ...(this.original_sn ? { original_sn: this.original_sn } : {}),
            ...(this.rated_capacity ? { rated_capacity: this.rated_capacity } : {}),
            ...(this.pv_lower_limit ? { pv_lower_limit: this.pv_lower_limit } : {}),
            ...(this.nexus_asset_id ? { nexus_asset_id: this.nexus_asset_id } : {}),
          });
          if (res?.success === true) {
            const response = await this.fetchData();
            this.newDeviceInfomation = res.data;
            this.handleTurnOffModalEdit();
            this.handleTurnOffModalDetail();
            if (response.success) {
              this.handleTurnOnModalEditSuccess();
            }
          }
        }
      } else {
        const result = await this.$validator.validateAll();
        if (result) {
          const res = await this.addDevice({
            site_id: this.site.id,
            sn: this.sn,
            name: this.name?.trim(),
            type: this.type.code,
            model: this.model,
            brand: this.brand,
            ...(this.original_sn ? { original_sn: this.original_sn } : {}),
            ...(this.rated_capacity ? { rated_capacity: this.rated_capacity } : {}),
            ...(this.pv_lower_limit ? { pv_lower_limit: this.pv_lower_limit } : {}),
            ...(this.nexus_asset_id ? { nexus_asset_id: this.nexus_asset_id } : {}),
          });
          if (res?.success === true) {
            const response = await this.fetchData();
            this.newDeviceInfomation = res.data;
            this.handleTurnOffModalAdd();
            if (response.success) {
              this.handleTurnOnModalAddSuccess();
            }
          }
        }
      }
    },

    handleResize() {
      this.isSmallScreen = window.innerWidth < 1440;
    },
    handleView(item) {     
      this.showModalDetail = {
        isShow: true,
        data: item,
      };
      this.newDeviceInfomation = item;
    },
    handleAddEdit(item) {
      if(item) {
        this.site = this.listSites.find(it => it.id === item.site_id); 
        this.name= item.name;
        this.sn = item.sn;
        this.nexus_asset_id = String(item.nexus_asset_id);
        // this.type = this.types?.find((it) => it.code == item.type);
        this.model = item.model;
        this.brand = item.brand;
        this.original_sn = item.original_sn;
        this.rated_capacity = item.rated_capacity;
        this.pv_lower_limit = item.pv_lower_limit;
        this.idEdit= item.id;
        this.showModal = {
          isShow: true,
          data: item,
          id: item.id,
        };
      }else{
        this.handleResetForm();
        this.showModal = {
          isShow: true,
          data: null,
        };
      }
    },
    handleDelete(item) {
      this.showDeleteConfirm = {
        isShow: true,
        data: item,
      };
    },
    handleOffConfirmDelete() {
      this.showDeleteConfirm = {
        isShow: false,
        data: null,
      };
    },
    async handleDeleteSuccess() {
      const res = await this.deleteDevice({id: this.showDeleteConfirm.data.id});
      if (res.data.success) {
        const response = await this.fetchData();
        if(response.success) {
          this.handleOffConfirmDelete();
          this.handleOffConfirmDelete();
          this.handleTurnOffModalDetail();
          this.showDeleteSuccess = true;
        }
      }
    },
    handleTurnOffDeleteSuccess() {
      this.showDeleteSuccess = false;
    },
    
    handleTurnOffModalAdd() {
      this.showModal = {
        isShow: false,
        data: null,
        id: null,
      };
    },
    handleTurnOffModalDetail() {
      this.showModalDetail = {
        isShow: false,
        data: null,
      };
    },
    handleTurnOnModalAddSuccess() {
      this.showModalAddSuccess = true;
    },
    handleTurnOffModalAddSuccess() {
      this.showModalAddSuccess = false;
    },
    handleBtnAddModalAddSuccess() {
      this.showModalAddSuccess = false;
      this.showModal = {
        isShow: true,
        data: null,
        id: null,
      }
      this.handleResetForm();
    },
    handleTurnOffModalEdit() {
      this.showModal = {
        isShow: false,
        data: null,
        id: null,
      };
    },
    handleTurnOnModalEditSuccess() {
      this.showModalEditSuccess = true;
    },
    handleTurnOffModalEditSuccess() {
      this.showModalEditSuccess = false;
    },
    handleSearch() {
      this.page = 1
      this.fetchData();
    },
    onChangePage(page) {
      this.page = page
      this.fetchData({ page });
    },
    handleSort({ sort_filter, sort }) {
      this.data_sort = sort.join(',')
      this.data_sort_filter= sort_filter.join(',')
      this.fetchData();
    },

    handleResetForm(){
      this.site_name = "";
      this.site = null;
      this.name= "";
      this.sn = "";
      this.type = null;
      this.model = "";
      this.brand = "";
      this.original_sn = "";
      this.rated_capacity = "";
      this.pv_lower_limit = "";
      this.nexus_asset_id= "";
    }
  },

  watch: {
    sn(newVal) {
      if (!newVal || newVal.length < 2) return;

      const prefix = newVal.substring(0, 2); // 01, 02, 03...

      const found = this.types.find(t => t.id === prefix);

      if (found) {
        this.type = found; // update SelectComponent
      }
      else{
        this.type = null;
      }
    }
  },
};
</script>

<style scoped lang="scss">
@import "./deviceManager.scss";
</style>
